import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React, { useEffect, useLayoutEffect, useRef } from 'react';
import i18n from 'i18next';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
var t = i18n.getFixedT(null, 'traffic-statistic');
var TerminalParkingCountTendCard = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  });

  _objectDestructuringEmpty(_useSelector);

  var dispatch = useDispatch();
  var chartXY = useRef();
  var categoryAxis = useRef();
  var terminalTrendChartData = props.terminalTrendChartData;
  useLayoutEffect(function () {
    chartXY.current = am4core.create('terminal-parking-count-chart', am4charts.XYChart);
    chartXY.current.hiddenState.properties.opacity = 0;
    categoryAxis.current = chartXY.current.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.current.dataFields.category = 'time';
    categoryAxis.current.dataItems.template.text = '{time}';
    categoryAxis.current.renderer.grid.template.location = 0;
    categoryAxis.current.renderer.minGridDistance = 50; // categoryAxis.current.adapter.add("tooltipText", (tooltipText, target) => {
    //     return handleTimeText(categoryAxis.current.tooltipDataItem.dataContext.time)
    // })

    var label = categoryAxis.current.renderer.labels.template;
    label.maxWidth = 90;
    label.fontSize = 12;
    label.rotation = -45;
    label.horizontalCenter = "right";
    label.dy = -10;
    label.dx = 10; // Set Chart 1

    var valueAxis = chartXY.current.yAxes.push(new am4charts.ValueAxis()); // valueAxis.title.text = 'abcd'
    // valueAxis.height = am4core.percent(50)

    valueAxis.renderer.minGridDistance = 20;
    valueAxis.min = 0; // set series
    // let series1 = chartXY.current.series.push(new am4charts.LineSeries())
    // series1.dataFields.categoryX = 'time'
    // series1.dataFields.valueY = 'value1'
    // series1.tooltipText = `{valueName1}:{valueY}`
    // series1.name = '金福路'
    // series1.strokeWidth = 2
    // let series2 = chartXY.current.series.push(new am4charts.LineSeries())
    // series2.dataFields.categoryX = 'time'
    // series2.dataFields.valueY = 'value2'
    // series2.tooltipText = `{valueName2}:{valueY}`
    // series2.name = `過港隧道`
    // series2.strokeWidth = 2
    // --- add data and add series

    _.map(terminalTrendChartData, function (el, index) {
      var seriesId = chartXY.current.series.length + 1; // Update data

      for (var i = 0; i < el.length; i++) {
        if (_.isEmpty(chartXY.current.data[i])) chartXY.current.data[i] = {};
        if (_.isEmpty(chartXY.current.data[i]['time'])) chartXY.current.data[i]['time'] = el[i].time;
        chartXY.current.data[i]["value" + seriesId] = el[i].value;
      } // Create series


      var series = new am4charts.LineSeries(); // series.data = chart.data

      series.dataFields.categoryX = "time";
      series.dataFields.valueY = "value" + seriesId;
      series.tooltipText = "".concat(index, ": {valueY}");
      series.name = index;
      series.strokeWidth = 2; // series.tensionX = 0.7
      // series.fillOpacity = 0.2
      // series.stacked = true

      chartXY.current.series.push(series);
    }); // let labelBullet = series.bullets.push(new am4charts.LabelBullet())
    // labelBullet.locationY = 0.5
    // labelBullet.label.hideOversized = true
    // Add a legend


    chartXY.current.legend = new am4charts.Legend();
    chartXY.current.legend.position = 'right';
    chartXY.current.legend.scrollable = true;
    chartXY.current.legend.maxWidth = '100';
    chartXY.current.legend.fontSize = '12'; // Add cursor

    chartXY.current.cursor = new am4charts.XYCursor(); //data 
    // chartXY.current.data = testData
    // hide amcharts4 logo

    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    return function () {
      chartXY.current.dispose();
    };
  }, [JSON.stringify(terminalTrendChartData)]); // usefEffect(() => {
  //     chartXY.current.data = xxxx
  // }, [JSON.stringify(terminalTrendChartData)])

  return /*#__PURE__*/React.createElement("div", {
    id: "terminal-parking-count-chart",
    className: "chart"
  });
});
export default TerminalParkingCountTendCard;